export default "__VITE_ASSET__EKU59wKM__"